angular.module("vgresiduos").controller("CostCenterListCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, "organizacao/centros-de-custo");
		};
	}
]);
